enum InlineMessageIconEnum {
	information = 'information-circle',
	incorrect = 'incorrect',
	warning = 'warning-triangle',
	checkmark = 'checkmark-circle'
}

export default InlineMessageIconEnum;
